import { Box, Paper, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './translations.json';
import { type FC } from 'react';

type SupportedLanguage = keyof typeof translations;

interface ApplicationSubmittedProps {
    isUpdate: boolean;
}

const ApplicationSubmitted: FC<ApplicationSubmittedProps> = ({ isUpdate }) => {
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 3, sm: 5 },
                width: '100%',
                maxWidth: 560,
                mx: 'auto',
                textAlign: 'center',
                color: '#f8fafc',
                backgroundColor: '#121316',
                border: '1px solid #23262d',
                borderRadius: 2,
            }}
        >
            <Box sx={{ mb: 2 }}>
                <FontAwesomeIcon icon={faCircleCheck} size="3x" color="#22c55e" />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: '#ffffff' }}>
                {isUpdate ? content.update.title : content.create.title}
            </Typography>
            <Typography variant="body1" sx={{ color: '#cbd5e1' }}>
                {isUpdate ? content.update.message : content.create.message}
            </Typography>
        </Paper>
    );
};

export default ApplicationSubmitted;